import {
  FormControl as MuiFormControl,
  FormControlProps as MuiFormControlProps,
  styled,
} from "@mui/material";

const StyledFormControl = styled(MuiFormControl)(() => ({
  // ... existing styles
}));

interface FormControlProps extends MuiFormControlProps {
  children: React.ReactNode;
}

export const FormControl: React.FC<FormControlProps> = ({ children, ...props }) => {
  return <StyledFormControl {...props}>{children}</StyledFormControl>;
};

export default FormControl;
